import { Component, OnInit, HostListener, Renderer2, ViewChild, ElementRef, SecurityContext } from '@angular/core';
import { StaticContentService } from '../service/satic-content-service/static-content.service';
import { DomSanitizer} from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';

import { LaunchParams } from '../shared/Models/LaunchParams';
import { CommonService } from '../service/common-service/common.service';
import { SaveStatusParam } from '../shared/Models/SaveStautusParams';
import { trigger, transition, animate, style, state } from '@angular/animations';
import { Constant, UBTConstants } from '../shared/constant';
import { MatDialog } from '@angular/material/dialog';
declare function UBTWorkerProcess(verbtype: string, activityname: string, extensions: Map<any, any>, resultObject: null, saveStatementCallback: null, Common: typeof UBTConstants, userID: string, role: string): any;
@Component({
  selector: 'app-static-content',
  templateUrl: './static-content.component.html',
  styleUrls: ['./static-content.component.css'],
  animations: [
    trigger('slideInOut', [
      state('open', style({ transform: 'translate(+100%)' })),
      state('closed', style({ transform: 'translate(0%)' })),
      transition('open => closed', [
        animate('200ms ease-in', style({ transform: 'translateX(0%)' }))
      ]),
      transition('closed => open', [
        animate('200ms ease-in', style({ transform: 'translateX(+100%)' }))
      ]),
    ]),
  ]
})
export class StaticContentComponent implements OnInit {

  @ViewChild('parentIFrame') parentIFrame: any;
  IsReadOnlyEHRLaunched = false;
  Iframeheight!: number;
  LaunchParams: LaunchParams;
  entrykey!: string;
  IsLMSLaunch!: boolean;
  IsLTIChildFrameVisible = false;
  IsEHRLaunched = false;
  learningSessionDetailId = 0;
  PreviewMode!: boolean;
  staticContentEntryURL!: string;
  Second: any = '00';
  Minute: any = '00';
  Hours: any = '00';
  Delay = 1000;
  TimeStamp = '00:00:00';
  timeSpentinWords = "";
  Param!: object;
  StaticContentIframe: string = '';
  StaticContentChildIframe: string = '';
  public style: object = {};
  ContentID = '0';
  TargetIframeID!: string;
  width = 475;
  isMobile = false;
  Old_XCoordinate = 0;
  Grabber = false;
  IsStaticContentModuleSynced = false;
  BookMarkId!: string;
  learningActivityName: string = '';
  learningUnitName: string = '';
  parentLearningActivityID!: number;
  parentLearningUnitID!: number;
  constructor(private sanitizer: DomSanitizer, private staticContentService: StaticContentService, private route: ActivatedRoute,
    public dialog: MatDialog, private commonService: CommonService, private router: Router,
    private renderer: Renderer2, private elementRef: ElementRef) {
    this.LaunchParams = new LaunchParams();
  }

  ngOnInit(): void {
    window.self.parent.postMessage('shellBlockUI', Constant.OriginUrlPattern);
    this.entrykey = this.route.snapshot.queryParams.EntryKey === undefined ? '' : this.route.snapshot.queryParams.EntryKey;
    this.IsLMSLaunch = this.route.snapshot.queryParams.lms === undefined ? false : this.route.snapshot.queryParams.lms;
    this.staticContentEntryURL = this.route.snapshot.url[0].path;
    this.StartTimer();
    this.isMobile = this.checkMobile();
    this.staticContentService.GetStaticContentDetails(encodeURI(this.entrykey), this.IsLMSLaunch).subscribe((data: any) => {
      if (data != null) {
        this.LaunchParams.LearningUnitId = data.learningUnitID;
        this.parentLearningUnitID = data.learningUnitID;
        this.LaunchParams.ApplicationId = data.applicationID;
        this.LaunchParams.LearningActivityId = data.learningActivityID;
        this.LaunchParams.InstitutionId = data.institutionID;
        this.LaunchParams.InstitutionName = data.institutionName;
        this.LaunchParams.AuthorizationId = data.authorizationID;
        this.LaunchParams.CohortId = data.cohortID;
        this.LaunchParams.CohortName = data.cohortName;
        this.LaunchParams.ConsortiumId = data.consortiumID;
        this.LaunchParams.ConsortiumName = data.consortiumName;
        this.LaunchParams.DocumentTarget = data.documentTarget;
        this.LaunchParams.ExternalSourceName = data.externalSourceName;
        this.LaunchParams.InstitutionPurchaseId = data.institutionPurchaseID;
        this.LaunchParams.LearningActivityTypeId = this.parentLearningActivityID = data.learningActivityTypeID;
        this.LaunchParams.LearningUnitResourceId = data.learningUnitResourceID;
        this.LaunchParams.Role = data.role;
        this.LaunchParams.customParameters = data.customParameters;
        this.LaunchParams.BookMarkLocation = data.bookMarkLocation;
        this.LaunchParams.EndTime = data.endTime;
        this.LaunchParams.FrameScrolling = data.frameScrolling;
        this.LaunchParams.IFrameStyle = data.iFrameStyle;
        this.LaunchParams.LearningSessionDetailId = data.learningSessionDetailID;
        this.LaunchParams.LearningUnitAttemptID = data.learningUnitAttemptID;
        this.LaunchParams.RemediationLink = data.remediationLink;
        this.LaunchParams.ResourceID = data.resourceID;
        this.LaunchParams.ResourceLocation = data.resourceLocation;
        this.LaunchParams.ShouldShowheader = data.shouldShowheader;
        this.LaunchParams.StartTime = data.startTime;
        this.LaunchParams.UserID = data.userID;
        this.LaunchParams.IsLTIModule = data.isLTIModule;
        this.LaunchParams.IsRemedaition = data.isRemediationModule;
        this.LaunchParams.Environment = data.environment;
        this.LaunchParams.ResourceTypeId = data.resourceTypeID;
        UBTConstants.Environment = data.environment;
        this.learningActivityName = data.learningActivityName;
        this.learningUnitName = data.learningUnitName;
        if (data.urlEncodeCustomParameters == "" || data.urlEncodeCustomParameters == null)
          this.LaunchParams.UrlEncodeCustomParameters = "%5B%7B%27name%27%3A%27is_deep_linking%27%2C%27value%27%3A%27false%27%7D%5D";
        else
          this.LaunchParams.UrlEncodeCustomParameters = data.urlEncodeCustomParameters;
        this.LaunchParams.customParameters = JSON.parse(decodeURIComponent(this.LaunchParams.UrlEncodeCustomParameters).replace(/'/g, '"'));
        const attemptIDParam = { name: 'static_content_attempt_id', value: this.LaunchParams.LearningUnitAttemptID.toString() };
        this.LaunchParams.customParameters.push(attemptIDParam);
        this.StaticContentIframe = this.LaunchParams.ResourceLocation;
        this.Iframeheight = window.innerHeight - 20;
        window.self.parent.postMessage('shellUnblockUI', Constant.OriginUrlPattern);
        if (this.LaunchParams.IsLTIModule) {
          this.router.navigate(['LTI'], { queryParams: { data: JSON.stringify(this.LaunchParams) }, skipLocationChange: true });
        }
        this.commonService.startInactivityTimer(true);
        this.StaticContentHeartBeat();
      }
    },
      err => {
        window.self.parent.postMessage('shellUnblockUI', Constant.OriginUrlPattern);
        console.log(err);
      });
  }
  checkMobile(): boolean {
    return window.navigator.maxTouchPoints > 0;
  }
  IsvalidJSON(str: string): boolean {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }
  @HostListener('window:message', ['$event'])
  receiveCloseEvent(event: MessageEvent) {
    // if(event.data.indexOf('|') == -1)
    if (this.IsvalidJSON(event.data)) {
      const messageObj = JSON.parse(event.data);
      if (messageObj.MessageName == 'LaunchEHRT' && !this.IsReadOnlyEHRLaunched) {
        this.IsReadOnlyEHRLaunched = true;
        this.ContentID = messageObj.ContentID;
        this.TargetIframeID = messageObj.TargetIframeID;
        this.LoadChildFrame();
      }
    }
    if (typeof event.data == 'string') {
      const parameters = event.data.split('|');
      switch (parameters[0]) {
        case 'ShowHideChart':
          this.ToggleChart();
          if (!this.IsEHRLaunched) {
            this.LoadChildFrame();
          }
          break;
        case 'CloseAttempt':
          this.StaticContentHeartBeat();
          break;
      }
      if (event.data && typeof event.data === 'string' && event.data.indexOf('{') == 0) {
        let contentEvent = JSON.parse(event.data);
        console.log(contentEvent);
        let extensions = new Map();
        extensions.set('name', this.learningActivityName + ' - ' + this.learningUnitName);
        extensions.set('activity-type-id', '14');
        extensions.set('learning-activity-id', this.LaunchParams.LearningActivityId);
        extensions.set('learning-activity-type-id', this.parentLearningActivityID);
        extensions.set('learning-unit-id', this.parentLearningUnitID);
        let eventType = contentEvent.MessageName;
            switch (eventType) {
              case 'Click':
                this.BookMarkId = contentEvent.Title;                     
                break;              
              case 'studentprogressedpage':
                UBTWorkerProcess(UBTConstants.VerbTypeProgressed,UBTConstants.ActivityNamePage,extensions,null,null,UBTConstants,this.LaunchParams.UserID.toString(), this.LaunchParams.Role.toLowerCase());
                break;
              case 'studentrepeatedpage':
                UBTWorkerProcess(UBTConstants.VerbTypeRepeated,UBTConstants.ActivityNamePage,extensions,null,null,UBTConstants,this.LaunchParams.UserID.toString(), this.LaunchParams.Role.toLowerCase());
                break;
              case 'studentscrolledpage':
                UBTWorkerProcess(UBTConstants.VerbTypeScrolled,UBTConstants.ActivityNamePage,extensions,null,null,UBTConstants,this.LaunchParams.UserID.toString(), this.LaunchParams.Role.toLowerCase());
                break;
              case 'studentlaunchedmenu':
                UBTWorkerProcess(UBTConstants.VerbTypeLaunched,UBTConstants.ActivityNameMenu,extensions,null,null,UBTConstants,this.LaunchParams.UserID.toString(), this.LaunchParams.Role.toLowerCase());
                break;
              case 'studentclosedmenu':
                UBTWorkerProcess(UBTConstants.VerbTypeClosed,UBTConstants.ActivityNameMenu,extensions,null,null,UBTConstants,this.LaunchParams.UserID.toString(), this.LaunchParams.Role.toLowerCase());
                break;
              case 'studentselectedanswer':
                UBTWorkerProcess(UBTConstants.VerbTypeSelected,UBTConstants.ActivityNameAnswer,extensions,null,null,UBTConstants,this.LaunchParams.UserID.toString(), this.LaunchParams.Role.toLowerCase());
                break;
              case 'studentsubmittedanswer':
                UBTWorkerProcess(UBTConstants.VerbTypeSubmitted,UBTConstants.ActivityNameAnswer,extensions,null,null,UBTConstants,this.LaunchParams.UserID.toString(), this.LaunchParams.Role.toLowerCase());
                break;
              case 'studentplayedvideo':
                UBTWorkerProcess(UBTConstants.VerbTypePlayed,UBTConstants.ActivityNameVideo,extensions,null,null,UBTConstants,this.LaunchParams.UserID.toString(), this.LaunchParams.Role.toLowerCase());
                break;
              case 'studentpausedvideo':
                UBTWorkerProcess(UBTConstants.VerbTypePaused,UBTConstants.ActivityNameVideo,extensions,null,null,UBTConstants,this.LaunchParams.UserID.toString(), this.LaunchParams.Role.toLowerCase());
                break;
              case 'studentcompletedvideo':
                UBTWorkerProcess(UBTConstants.VerbTypeCompleted,UBTConstants.ActivityNameVideo,extensions,null,null,UBTConstants,this.LaunchParams.UserID.toString(), this.LaunchParams.Role.toLowerCase());
                break;
              case 'studentlaunchedremediation':
                UBTWorkerProcess(UBTConstants.VerbTypeLaunched,UBTConstants.ActivityNameRemediation,extensions,null,null,UBTConstants,this.LaunchParams.UserID.toString(), this.LaunchParams.Role.toLowerCase());
                break;
              case 'studentsubmitteddrillquestionanswer':
                UBTWorkerProcess(UBTConstants.VerbTypeSubmitted,UBTConstants.ActivityNameDrillQuestionAnswer,extensions,null,null,UBTConstants,this.LaunchParams.UserID.toString(), this.LaunchParams.Role.toLowerCase());
                break;
            } 
      }
    }
  }

  LoadChildFrame(): void {
    if (this.IsLTIChildFrameVisible || this.IsReadOnlyEHRLaunched) {
      this.commonService.GetEHRLearningUnitDetails(this.LaunchParams.LearningUnitId, this.ContentID).subscribe((data: any) => {
        if (data != null) {
          this.LaunchParams.LearningUnitId = data.learningUnitID;
          this.LaunchParams.LearningActivityTypeId = data.learningActivityTypeID;
          this.LaunchParams.LearningUnitResourceId = data.learningUnitResourceID;
          this.IsEHRLaunched = true;
          this.LaunchEHR();
        }
      },
        err => {
          console.log(err);
        });
    }
  }
  LaunchEHR(): void {
    this.commonService.LTILaunch(this.LaunchParams).subscribe((data: any) => {
      if (data != null) {
        if (this.IsReadOnlyEHRLaunched) {
          const ContentIframeParams = {
            TargetIframId: this.TargetIframeID,
            ContentUrl: this.sanitizer.sanitize(SecurityContext.RESOURCE_URL,
              this.sanitizer.bypassSecurityTrustResourceUrl(data))
          };
          const iframe = document.getElementById('StaticContentIFrame') as HTMLIFrameElement;
          if(iframe.contentWindow != null)
          iframe.contentWindow.postMessage('SetClientChartSrc|' + JSON.stringify(ContentIframeParams), '*');
        }
        else {
          this.StaticContentChildIframe = data;
        }
        this.LaunchParams.LearningUnitId = data.learningUnitId;
      }
    },
      err => {
        window.self.parent.postMessage('shellUnblockUI', Constant.OriginUrlPattern);
        console.log(err);
      });
  }
  StartTimer(): void {
    setInterval(() => {
      this.Second = parseInt(this.Second, 10) + this.Delay / 1000;
      if (this.Second === 60) {
        this.Minute = parseInt(this.Minute, 10) + 1;
        this.Minute = this.Minute > 9 ? this.Minute : ('0' + this.Minute);
        this.Second = 0;
      }
      if (this.Minute === 60) {
        this.Hours = parseInt(this.Hours, 10) + 1;
        this.Hours = this.Hours > 9 ? this.Hours : ('0' + this.Hours);
        this.Minute = 0;
      }
      if (this.Second === 0 || this.Second === 30) {
        this.StaticContentHeartBeat();
      }
      this.Second = this.Second > 9 ? this.Second : ('0' + this.Second);
      this.TimeStamp = `${this.Hours}:${this.Minute}:${this.Second}`;
      this.setTimeSpentLabel();
    }, 1000);
  }

  setTimeSpentLabel(){
    let hr = Number(this.Hours);
     let min = Number(this.Minute);
     let sec = Number(this.Second);
     this.timeSpentinWords = "";
     if(hr > 0){
      this.timeSpentinWords = `${hr} ${hr > 1 ? 'hours' : "hour"}  `
     }
     if(min > 0){
      this.timeSpentinWords =  `${this.timeSpentinWords } ${min} ${min > 1 ? "minutes":"minute"}`;
     }
     if(sec > 0){
      this.timeSpentinWords = `${this.timeSpentinWords } ${sec} ${sec > 1 ? "seconds": "second"}`;
     }
     this.timeSpentinWords = `Time Spent: ${this.timeSpentinWords }`;
  }

  StaticContentHeartBeat(): void {
    if (this.LaunchParams.IsRemedaition === false) {
      let saveStatusParams: SaveStatusParam = {
        AuthorizationID: this.LaunchParams.AuthorizationId,
        LearningSessionDetailID: this.LaunchParams.LearningSessionDetailId,
        BookMarkId: this.BookMarkId,
      };
      this.commonService.SaveStatus(saveStatusParams).subscribe(
        (data: any) => {
          const saveStatusObj = {
            LearningActivityID: data.learningActivityID,
            LearningUnitID: data.learningUnitID,
            AuthorizationID: data.authorizationID,
            ResourceLocation: data.resourceLocation,
            ResourceInstanceID: data.resourceInstanceID,
            StatusID: data.statusID,
            StartTime: data.startTime,
            EndTime: data.endTime,
            IsCompleted: data.isCompleted,
            UserID: data.userID,
            LearningUnitAttemptID: data.learningUnitAttemptID,
            LearningSessionDetailID: data.learningSessionDetailID
          };
          const res = JSON.parse(JSON.stringify(saveStatusObj));
          window.self.parent.postMessage("UpdateBookMark|" + JSON.stringify(true), Constant.OriginUrlPattern);
          if (this.IsStaticContentModuleSynced) {
            window.self.parent.postMessage('SyncSkillsModulesTime|' + JSON.stringify(res), Constant.OriginUrlPattern);
          }
          else {
            window.self.parent.postMessage('SyncSkillsModules|' + JSON.stringify(res), Constant.OriginUrlPattern);
            this.IsStaticContentModuleSynced = true;
          }
          //let student portal do the redirect
          //window.self.parent.postMessage('NavigateToProducts|', Constant.OriginUrlPattern);
        },
        err => {
          console.log(err);
        });
    }
  }

  ToggleChart(): void {
    if (!this.IsReadOnlyEHRLaunched) {
      this.IsLTIChildFrameVisible = !this.IsLTIChildFrameVisible;
    }
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (!this.Grabber) {
      return;
    }
    this.resizer(this.Old_XCoordinate - event.clientX);
    this.Old_XCoordinate = event.clientX;
  }

  @HostListener('document:mouseup', ['$event'])
  onMouseUp(event: MouseEvent) {
    this.Grabber = false;
    this.SetPointer('auto');
  }
  resizer(offsetY: number): void {
    this.width += offsetY;
  }

  @HostListener('document:mousedown', ['$event'])
  onMouseDown(event: MouseEvent) {
    this.SetPointer('none');
    this.Grabber = true;
    this.Old_XCoordinate = event.clientX;
  }

  SetPointer(value: string) {
    const iframe = this.elementRef.nativeElement.querySelector('iframe');
    this.renderer.setStyle(iframe, 'pointer-events', value);
    const ehriframecontainer = this.elementRef.nativeElement.querySelector('#LTIChildFrame');
    this.renderer.setStyle(ehriframecontainer, 'pointer-events', value);
  }
}
